export default {"src":"/_next/static/media/dog_24.b6e7299f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};